/* PRESTIGE — Panier coulissant : upsells « Complète ton look » + boutons express.
   Dépend de cart-drawer.js (Dawn) : on attend que <cart-drawer> soit défini. */
(function () {
  'use strict';

  function sectionsToRender() {
    return ['cart-drawer', 'cart-icon-bubble'];
  }

  function initPaymentButtons() {
    try {
      if (window.Shopify && window.Shopify.PaymentButton && typeof window.Shopify.PaymentButton.init === 'function') {
        window.Shopify.PaymentButton.init();
      }
    } catch (e) {
      /* silencieux */
    }
  }

  /* Après chaque re-rendu du tiroir (ajout produit, pack, upsell), on relance les boutons express. */
  customElements.whenDefined('cart-drawer').then(function () {
    var proto = customElements.get('cart-drawer').prototype;
    var original = proto.renderContents;
    if (!original || original.__phPatched) return;
    proto.renderContents = function (parsedState) {
      original.call(this, parsedState);
      setTimeout(initPaymentButtons, 50);
    };
    proto.renderContents.__phPatched = true;
  });

  /* Quantité modifiée / ligne supprimée : cart.js remplace .drawer__inner → relance aussi. */
  document.addEventListener('DOMContentLoaded', function () {
    if (typeof subscribe === 'function' && window.PUB_SUB_EVENTS) {
      subscribe(PUB_SUB_EVENTS.cartUpdate, function () {
        setTimeout(initPaymentButtons, 50);
      });
    }
  });

  if (!customElements.get('prestige-cart-upsell')) {
    customElements.define(
      'prestige-cart-upsell',
      class PrestigeCartUpsell extends HTMLElement {
        constructor() {
          super();
          this.addEventListener('click', this.onClick.bind(this));
        }

        onClick(event) {
          var pill = event.target.closest('[data-upsell-variant]');
          if (pill && this.contains(pill)) {
            event.preventDefault();
            this.selectVariant(pill);
            return;
          }
          var btn = event.target.closest('[data-upsell-add]');
          if (btn && this.contains(btn)) {
            event.preventDefault();
            this.add(btn);
          }
        }

        selectVariant(pill) {
          if (pill.disabled) return;
          var item = pill.closest('[data-upsell-item]');
          item.querySelectorAll('[data-upsell-variant]').forEach(function (p) {
            p.setAttribute('aria-pressed', p === pill ? 'true' : 'false');
          });
          item.dataset.variantId = pill.dataset.upsellVariant;
          var price = item.querySelector('[data-upsell-price]');
          if (price && pill.dataset.price) price.textContent = pill.dataset.price;
        }

        add(btn) {
          var item = btn.closest('[data-upsell-item]');
          var variantId = parseInt(item.dataset.variantId, 10);
          if (!variantId) return;

          var drawer = document.querySelector('cart-drawer');
          var label = btn.dataset.label || btn.textContent;
          btn.textContent = btn.dataset.labelBusy || '…';
          item.classList.add('is-busy');

          fetch(window.Shopify.routes.root + 'cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/javascript' },
            body: JSON.stringify({
              items: [{ id: variantId, quantity: 1 }],
              sections: sectionsToRender(),
              sections_url: window.location.pathname,
            }),
          })
            .then(function (r) {
              return r.json();
            })
            .then(function (data) {
              if (data.status) throw new Error(data.description || data.message || 'error');

              if (typeof publish === 'function' && window.PUB_SUB_EVENTS) {
                publish(PUB_SUB_EVENTS.cartUpdate, {
                  source: 'prestige-cart-upsell',
                  productVariantId: variantId,
                  cartData: data,
                });
              }

              if (drawer && typeof drawer.renderContents === 'function') {
                drawer.classList.remove('is-empty');
                drawer.renderContents(data);
              } else {
                window.location.href = window.Shopify.routes.root + 'cart';
              }
            })
            .catch(function () {
              btn.textContent = label;
              item.classList.remove('is-busy');
              var errors = document.getElementById('CartDrawer-CartErrors');
              if (errors && window.cartStrings) errors.textContent = window.cartStrings.error;
            });
        }
      }
    );
  }
})();
